import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-agency",
  "use": "icon-agency-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-agency\"><defs><style type=\"text/css\"></style></defs><path d=\"M776.3 574.9c-54 0-101.9-26.3-131.6-66.7-29.8 40.4-77.7 66.7-131.6 66.7-53.9 0-101.8-26.3-131.6-66.7-6.3 8.6-13.4 16.5-21.3 23.8-33.6 30.8-79.1 46.2-124.9 42.3-83.5-7.3-148.9-80.7-148.9-167.1 0-21.3 5-42.7 14.6-61.8l73.1-146.3c26.4-52.7 79.3-85.4 138.2-85.4h401c58.9 0 111.9 32.7 138.2 85.4l73.3 146.7c9.4 18.7 14.4 39.7 14.6 60.6v4.8c0.2 90.4-73.1 163.7-163.1 163.7z\" p-id=\"5433\" /><path d=\"M776.3 630.7c-54 0-101.9-26.3-131.6-66.7-29.8 40.4-77.7 66.7-131.6 66.7-53.9 0-101.8-26.3-131.6-66.7-6.3 8.6-13.4 16.5-21.3 23.8-33.6 30.8-79.1 46.2-124.9 42.3-34.9-3-66.6-17.8-91.7-40.1v171.8c0 82.5 67.1 149.6 149.6 149.6h439.7c82.5 0 149.6-67.1 149.6-149.6V591.2c-28.6 24.6-65.7 39.5-106.2 39.5z\" p-id=\"5434\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/agency.svg
// module id = B+VF
// module chunks = 7